/* global localStorage */
import * as MutationTypes from 'store/mutation-types'
// init state
const state = {
  displayedScreeningEvent: null,
  displayedScreeningTab: 0,
  screeningAlerts: []
}

const getters = {
  displayedScreeningEvent() {
    return state.displayedScreeningEvent
  },
  displayedScreeningTab() {
    return state.displayedScreeningTab
  },
  screeningAlerts() {
    return state.screeningAlerts
  }
}

const mutations = {
  SET_DISPLAYED_SCREENING_EVENT(state, event) {
    state.displayedScreeningEvent = event
  },
  SET_DISPLAYED_SCREENING_TAB(state, tab) {
    state.displayedScreeningTab = tab
  },
  SET_SCREENING_ALERTS(state, alerts) {
    state.screeningAlerts = alerts
  }
}

const actions = {
  async setDisplayedScreeningEvent({ commit }, event) {
    await commit(MutationTypes.SET_DISPLAYED_SCREENING_EVENT, event)
  },
  async setDisplayedScreeningTab({ commit }, tab) {
    await commit(MutationTypes.SET_DISPLAYED_SCREENING_TAB, tab)
  },
  async setScreeningAlerts({ commit }, alerts) {
    await commit(MutationTypes.SET_SCREENING_ALERTS, alerts)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
